export enum TOAST_VARIANTS {
  POSITIVE = 'positive',
  WARNING = 'warning',
  NEGATIVE = 'negative',
  INFO = 'info',
}

export enum VISIBLE_ENUM {
  ENTERING = 0,
  VISIBLE = 1,
  EXITING = 2,
}
